export enum MmSideNavBarButtonsEnum {
  MainGroup = 'Main',
  FilterGroup = 'filter',
  FilterLayout = 'filter-layout',
  FilterPool = 'filter-pool',
  FilterStructure = 'filter-str',
  FilterFields = 'filter-fields',
  Costs = 'costs',
  CostsGroup = 'costs-group',
  CostsBackToProject = 'costs-back-to-project',
 // TimeTracking = 'time-tracking',
  Invoices = 'invoices',


  Faults = 'faults',
  UserSettingsBackToProject = 'user-settings-back-to-project',
  UserSettingsGroup = 'user-settings',
  UserSettingsVariables = 'user-settings-variables',
  CapacitorAppSettingsBackToProject = 'capacitor-app-settings-back-to-project',
  CapacitorAppSettings = 'capacitor-app-settings',

  ProjectSettingsGroup = 'project-settings',
  ProjectSettingsBackToMain = 'project-settings-back-to-main',
  ProjectSettingsCompanies = 'project-settings-companies',
  ProjectSettingsCrafts = 'project-settings-crafts',
  ProjectSettingsUserdefineds1 = 'project-settings-userdefineds1',
  ProjectSettingsUserdefineds2 = 'project-settings-userdefineds2',

  ProjectSettingsInformations = 'project-settings-informations',
  ProjectSettingsMaxLevel = 'project-settings-max-level',

  ProjectOverviewGroup = 'projects-overview-group',
  ProjectOverview = 'project-overview',
  ProjectOverviewBackToProject = 'project-overview-back-to-project',

  ProjectVariables = 'project-variables',
  Plans = 'plans',
  // Attachments = 'attachments',
  // SettingsGroup = 'settings',
  // SettingsFields = 'settings-fields',
  // SettingsCommon = 'settings-common',

  ProjectSettingsBimModels = 'project-settings-bim-models',
  ProjectSettingsStructures = 'project-settings-structures',
  ProjectSettingsBimSections = 'project-settings-bim-sections',
  ProjectSettingsPlans = 'project-settings-plans',

  MessageCenter = 'task-dashboard'
}
